import { createEffect } from 'effector';

import { apiFetch } from '@m/utils/http';

export const fetchForceCloseReasons = createEffect({
  handler: ({ visitId }: { visitId?: number } = {}) =>
    apiFetch('/specialist/visits/force-close-reasons', {
      params: visitId ? { visitId } : undefined,
    }),
});

export const forceCloseVisit = createEffect({
  handler: async ({
    visitId,
    forceCloseReasonId,
    payment,
  }: {
    forceCloseReasonId: number;
    payment: {
      amount: number;
      currency: string;
    } | null;
    visitId: number;
  }) =>
    apiFetch(`/specialist/visit/${visitId}/force-close`, {
      method: 'POST',
      body: {
        forceCloseReason: { id: forceCloseReasonId },
        ...(payment !== null && { payment }),
      },
    }),
});
